import { API_OFFICE_PREFIX, SuiteApiClient } from "@weco/suite-client";

export const officeApi = new SuiteApiClient(API_OFFICE_PREFIX);
